import { useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";
import FushimiInariToriiGates from "../assets/img/Blogs/Japan/FushimiInariToriiGates.jpg";
import LavenderFields from "../assets/img/Blogs/Japan/LavenderFields.jpg";
import MiyajimaToriiGate from "../assets/img/Blogs/Japan/MiyajimaToriiGate.jpg";
import OsakaCastle from "../assets/img/Blogs/Japan/OsakaCastle.jpg";
import TokyoSkyline from "../assets/img/Blogs/Japan/TokyoSkyline.jpg";

const Japan = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header></Header>
      <div className="mainContent blogDtlWrap">
        <div className="blogBannerWrap japanBlogBannerWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 col-lg-8">
                <div className="bannerDataWrap">
                  <h2>Japan’s Top 5 Must-Visit Places</h2>
                  <p>
                    Japan is a mesmerizing blend of tradition and modernity,
                    offering everything from ancient temples to futuristic
                    cities. Whether you're drawn to vibrant city life, historic
                    sites, or natural wonders, here are the top five must-visit
                    destinations in Japan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={TokyoSkyline} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>01.</span>
                  <h2> Tokyo – The City That Never Sleeps</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A futuristic city with neon streets, shopping, and anime
                      culture.
                    </p>
                  </div>
                  <p>
                    Tokyo, the capital of Japan, is a vibrant metropolis known
                    for its towering skyscrapers and historic landmarks.
                    Experience the organized chaos of Shibuya Crossing, Japan’s
                    busiest intersection. Visit Senso-ji Temple, Tokyo’s oldest
                    Buddhist temple, and explore Akihabara, a paradise for
                    anime, gaming, and tech lovers.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Shibuya Crossing</p>
                    </li>
                    <li>
                      <p>Senso-ji Temple</p>
                    </li>
                    <li>
                      <p>Akihabara</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img
                    src={FushimiInariToriiGates}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>02.</span>
                  <h2> Kyoto – The Heart of Tradition</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      The cultural heart of Japan, home to temples and scenic
                      beauty.
                    </p>
                  </div>
                  <p>
                    Step back in time in Kyoto, Japan’s ancient capital. Walk
                    through the Fushimi Inari Shrine, famous for its thousands
                    of red torii gates. Wander through the tranquil Arashiyama
                    Bamboo Forest, a breathtaking natural escape. Kyoto is also
                    home to stunning temples, traditional tea houses, and geisha
                    culture.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Fushimi Inari Shrine</p>
                    </li>
                    <li>
                      <p>Arashiyama Bamboo Forest</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={OsakaCastle} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>03.</span>
                  <h2>Osaka – Japan’s Kitchen</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>Known for food, nightlife, and its historic castle.</p>
                  </div>
                  <p>
                    Osaka is a food lover’s paradise, famous for takoyaki
                    (octopus balls) and okonomiyaki (savory pancakes). Explore
                    Dotonbori, a lively area filled with neon lights,
                    restaurants, and entertainment. Visit Osaka Castle, an
                    important historical landmark, and experience world-class
                    attractions at Universal Studios Japan.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Dotonbori</p>
                    </li>
                    <li>
                      <p>Osaka Castle</p>
                    </li>
                    <li>
                      <p>Universal Studios Japan</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={LavenderFields} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>04.</span>
                  <h2>Hokkaido – A Natural Wonderland</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A winter wonderland famous for skiing and flower fields.
                    </p>
                  </div>
                  <p>
                    Hokkaido is the perfect destination for nature lovers. In
                    winter, enjoy the Sapporo Snow Festival, featuring massive
                    ice sculptures and winter sports. In summer, visit Furano’s
                    lavender fields, a sea of purple flowers against a mountain
                    backdrop. The region is also known for its fresh seafood and
                    relaxing hot springs.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Sapporo Snow Festival</p>
                    </li>
                    <li>
                      <p> Lavender Fields</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction blogTopAttractionPadBtm">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={MiyajimaToriiGate} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>05.</span>
                  <h2> Hiroshima – A Place of Peace and Beauty</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A place of history, resilience, and breathtaking
                      landscapes.
                    </p>
                  </div>
                  <p>
                    Hiroshima is a city that tells a powerful story of
                    resilience. The Peace Memorial Park honors the victims of
                    the atomic bombing and promotes world peace. A short ferry
                    ride away, Miyajima Island is home to the iconic floating
                    Torii Gate and stunning hiking trails.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Peace Memorial Park</p>
                    </li>
                    <li>
                      <p>Miyajima Island</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="finalThouthWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Final Thoughts</h2>
                <p>
                  From Tokyo’s bright lights to Kyoto’s ancient temples, Japan
                  offers a journey like no other. Whether you're a foodie,
                  history buff, or nature enthusiast, Japan has something
                  unforgettable for everyone.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="styConnectedWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="styConnectedBox">
                  <div className="imgWrap">
                    <img src={TokyoSkyline} className="img-fluid" alt="" />
                  </div>
                  <div className="dataWrap">
                    <h2>Start planning your Japanese adventure today! </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default Japan;
